// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.checkbox-row[data-v-12fc1516] {\r\n  background-color: #f5f5f5;\n}\r\n", ""]);
// Exports
module.exports = exports;
